export class Ferie {
    id: number|undefined;
    label:string;
    ferieDate:string;
  }